import { Card, Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import MyAccountNav from '../components/MyAccountNav';
import ReferAFriendForm from '../features/customer/ReferAFriendForm';
import { selectToken } from '../features/user/userSlice';
import MyAccountPage from './MyAccountPage';

export default function ReferAFriendPage() {
  const token = useSelector(selectToken);

  if (!token) {
    return (
      <MyAccountPage />
    )
  }

  return (
    <Container fluid="lg" className='refer-a-friend-page'>
      <Row>
        <Col sm={12} md={3}>
          <MyAccountNav />
        </Col>
        <Col sm={12} md={9} className='d-flex flex-column my-5'>
          <Card className='font-barlow flex-fill' body>
            <h1 className='text-8xl text-center fw-700'>SEND A FREE BOX</h1>
            <h1 className='display-4 text-center fw-500'>GIVE 6 FREE MEALS ➡ GET $25</h1>
            <p className='fs-4 text-center'>Send your friends a
              <span className='fw-bold'> FREE BOX</span> of 6 Meals and when they complete their order, you’ll receive
              <span className='fw-bold'> $25</span> worth of Mighty Points!</p>
            <ReferAFriendForm />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}